// make the menu to open when mouse is hovering on top of it

// Restrict the script to the <header> header__inline element
document.querySelectorAll('header .header__inline-menu [id^="Details-"]').forEach((details) => {
  const summary = details.querySelector('summary');

  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', details.hasAttribute('open'));

  if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  // Expand on mouseover
  summary.addEventListener('mouseover', () => {
    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  });

  // Collapse when the mouse leaves the parent 'details' element
  details.addEventListener('mouseleave', () => {
    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
  });
});

